import React from 'react';
import styled from 'styled-components';
import { BreakpointsPx, colors, ImpContainer, ImpDivider, ImpFlex, ImpHidden, ImpSpacer, ImpText, MaxWidth, } from '../..';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${(props) => props.width || '100%'};
  height: 100%;
  max-width: 100vw;
  margin: 0 auto;
`;
const ButtonContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${MaxWidth.Button};
`;
export default function ImpAccountStatus({ headerImg, header, body1, body2, body3, headerCenterAlign, body1CenterAlign, body2CenterAlign, body3CenterAlign, showMobileDivider, buttons, width, }) {
    // To handle new-line char
    const paragraphStyle = {
        whiteSpace: 'pre-line',
    };
    const bodyParagraph = (body, bodyCenterAlign) => {
        if (typeof body === 'string') {
            return (React.createElement(ImpContainer, { textAlign: bodyCenterAlign ? 'center' : '', width: "100%" },
                React.createElement(ImpSpacer, { height: "xs" }),
                React.createElement(ImpText, { typography: "body2", color: colors.content.onSurfaceVariant },
                    React.createElement("span", { style: paragraphStyle }, body))));
        }
        else {
            return body;
        }
    };
    return (React.createElement(Container, { width: width },
        React.createElement(ImpFlex, { direction: "column", align: "center", fluid: true },
            React.createElement(ImpSpacer, { height: "2xl", mobileHeight: "xl" }),
            headerImg,
            React.createElement(ImpContainer, { textAlign: headerCenterAlign ? 'center' : '', width: "100%" },
                React.createElement(ImpText, { typography: "headline3" }, header)),
            body1 && bodyParagraph(body1, body1CenterAlign),
            body2 && bodyParagraph(body2, body2CenterAlign),
            body3 && bodyParagraph(body3, body3CenterAlign),
            React.createElement(ImpSpacer, { height: "l" })),
        showMobileDivider && buttons && (React.createElement(ImpHidden, { hideAbove: BreakpointsPx.Mobile, fluid: true },
            React.createElement(ImpDivider, { width: "100vx" }))),
        React.createElement(ImpSpacer, { height: "l" }),
        React.createElement(ButtonContainer, null, buttons),
        React.createElement(ImpSpacer, { height: "l" })));
}
//# sourceMappingURL=ImpAccountStatus.js.map